const dateFmt = new Intl.DateTimeFormat('th-TH', {
  timeZone: 'Asia/Bangkok',
  dateStyle: 'medium',
});

const dateTimeFmt = new Intl.DateTimeFormat('th-TH', {
  timeZone: 'Asia/Bangkok',
  dateStyle: 'medium',
  timeStyle: 'short',
});

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso.length === 10 ? `${iso}T00:00:00Z` : iso);
  return Number.isNaN(d.getTime()) ? '—' : dateFmt.format(d);
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '—' : dateTimeFmt.format(d);
}

export function formatSatang(satang: number | null | undefined): string {
  if (satang === null || satang === undefined) return '—';
  return (satang / 100).toLocaleString('th-TH', { style: 'currency', currency: 'THB' });
}

export function maskNationalId(last4: string | null | undefined): string {
  return last4 ? `x-xxxx-xxxxx-x-${last4}` : '—';
}

export function fullName(p: {
  title?: string | null;
  firstName: string;
  lastName: string;
}): string {
  return [p.title, p.firstName, p.lastName].filter(Boolean).join(' ');
}

export function ageFrom(birthDate: string | null | undefined): string {
  if (!birthDate) return '—';
  const born = new Date(`${birthDate}T00:00:00Z`);
  if (Number.isNaN(born.getTime())) return '—';
  const now = new Date();
  let age = now.getUTCFullYear() - born.getUTCFullYear();
  const m = now.getUTCMonth() - born.getUTCMonth();
  if (m < 0 || (m === 0 && now.getUTCDate() < born.getUTCDate())) age--;
  return `${age} ปี`;
}

export const BENEFICIARY_STATUS_TH: Record<string, string> = {
  screening: 'รอคัดกรอง',
  active: 'กำลังช่วยเหลือ',
  monitoring: 'ติดตามผล',
  graduated: 'พึ่งพาตนเองได้',
  closed: 'ปิดเคส',
  rejected: 'ไม่ผ่านเกณฑ์',
  deceased: 'เสียชีวิต',
};

export const CATEGORY_TH: Record<string, string> = {
  elderly: 'ผู้สูงอายุ',
  disabled: 'ผู้พิการ',
  child: 'เด็ก',
  patient: 'ผู้ป่วย',
  homeless: 'ไร้ที่อยู่',
  low_income: 'ผู้มีรายได้น้อย',
  disaster: 'ผู้ประสบภัย',
  other: 'อื่น ๆ',
};

export const RISK_TH: Record<string, string> = {
  low: 'ต่ำ',
  medium: 'ปานกลาง',
  high: 'สูง',
  critical: 'วิกฤต',
};
